<app-interceptor></app-interceptor>

<app-header *ngIf="exibirTemplate"></app-header>

<app-menu *ngIf="exibirTemplate"></app-menu>

<div>
  <section class="content-header"></section>

  <section class="content"
    [class.menu-escondido]="compartilhadoService.ocultarMenu && exibirTemplate"
    [class.menu-aberto]="!compartilhadoService.ocultarMenu && exibirTemplate"
    [style.padding-top.px]="exibirTemplate ? '50' : '0'">
    <div *ngIf="exibirTemplate" style="margin-left: 65px; padding: 1%;">
      <router-outlet></router-outlet> 
    </div>
    <router-outlet *ngIf="!exibirTemplate"></router-outlet>
 </section>
